"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IDEDirection = exports.EDirection = exports.IDEAlign = exports.EAlign = exports.IDEJustify = exports.EJustify = exports.EFlexTypes = void 0;
var EFlexTypes;
exports.EFlexTypes = EFlexTypes;

(function (EFlexTypes) {
  EFlexTypes[EFlexTypes["center"] = 0] = "center";
  EFlexTypes[EFlexTypes["start"] = 1] = "start";
  EFlexTypes[EFlexTypes["end"] = 2] = "end";
  EFlexTypes[EFlexTypes["center-start"] = 3] = "center-start";
  EFlexTypes[EFlexTypes["center-end"] = 4] = "center-end";
  EFlexTypes[EFlexTypes["start-center"] = 5] = "start-center";
  EFlexTypes[EFlexTypes["end-center"] = 6] = "end-center";
})(EFlexTypes || (exports.EFlexTypes = EFlexTypes = {}));

;
var EJustify;
exports.EJustify = EJustify;

(function (EJustify) {
  EJustify[EJustify["start"] = 0] = "start";
  EJustify[EJustify["end"] = 1] = "end";
  EJustify[EJustify["flex-start"] = 2] = "flex-start";
  EJustify[EJustify["flex-end"] = 3] = "flex-end";
  EJustify[EJustify["center"] = 4] = "center";
  EJustify[EJustify["left"] = 5] = "left";
  EJustify[EJustify["right"] = 6] = "right";
  EJustify[EJustify["normal"] = 7] = "normal";
  EJustify[EJustify["baseline"] = 8] = "baseline";
  EJustify[EJustify["first baseline"] = 9] = "first baseline";
  EJustify[EJustify["last baseline"] = 10] = "last baseline";
  EJustify[EJustify["space-around"] = 11] = "space-around";
  EJustify[EJustify["space-between"] = 12] = "space-between";
  EJustify[EJustify["space-evenly"] = 13] = "space-evenly";
  EJustify[EJustify["stretch"] = 14] = "stretch";
})(EJustify || (exports.EJustify = EJustify = {}));

;
var IDEJustify = EJustify["flex-start"];
exports.IDEJustify = IDEJustify;
var EAlign;
exports.EAlign = EAlign;

(function (EAlign) {
  EAlign[EAlign["normal"] = 0] = "normal";
  EAlign[EAlign["start"] = 1] = "start";
  EAlign[EAlign["end"] = 2] = "end";
  EAlign[EAlign["flex-start"] = 3] = "flex-start";
  EAlign[EAlign["flex-end"] = 4] = "flex-end";
  EAlign[EAlign["self-start"] = 5] = "self-start";
  EAlign[EAlign["self-end"] = 6] = "self-end";
  EAlign[EAlign["center"] = 7] = "center";
  EAlign[EAlign["baseline"] = 8] = "baseline";
  EAlign[EAlign["first baseline"] = 9] = "first baseline";
  EAlign[EAlign["last baseline"] = 10] = "last baseline";
  EAlign[EAlign["stretch"] = 11] = "stretch";
})(EAlign || (exports.EAlign = EAlign = {}));

;
var IDEAlign = EAlign.stretch;
exports.IDEAlign = IDEAlign;
var EDirection;
exports.EDirection = EDirection;

(function (EDirection) {
  EDirection[EDirection["row"] = 0] = "row";
  EDirection[EDirection["column"] = 1] = "column";
  EDirection[EDirection["row-reverse"] = 2] = "row-reverse";
  EDirection[EDirection["column-reverse"] = 3] = "column-reverse";
  EDirection[EDirection["initial"] = 4] = "initial";
  EDirection[EDirection["inherit"] = 5] = "inherit";
})(EDirection || (exports.EDirection = EDirection = {}));

;
var IDEDirection = EDirection.row;
exports.IDEDirection = IDEDirection;